import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    IsMobile: false,
    IsBlogPost: false,
    IsFacebook: false,
    IsSpotify: false,
    IsViolentNoise: false,
    IsRedesSociais: false,
    IsContato: false,
    IsPatrocinador: false,
    BlogPosts: Array(),
    IdToken: "",
    IdTokenExp: 0,
    MessageToken: "",
    UserId: '',
    DisplayName: '',
    Email: '',
    PhoneNumber: '',
    PhotoURL: '',
    Claims: {}
  },
  getters: {
    getMessageToken: state => {
      return state.MessageToken;
    },
    getUserId: state => {
      return state.UserId;
    },    
  },
  mutations: {
    setIsMobile(state, IsMobile) {
      state.IsMobile = IsMobile;
    },
    
    setIsBlogPost(state, IsBlogPost) {
      state.IsBlogPost = IsBlogPost;
    },
    
    setIsFacebook(state, IsFacebook) {
      state.IsFacebook = IsFacebook;
    },
    
    setIsSpotify(state, IsSpotify) {
      state.IsSpotify = IsSpotify;
    },
    
    setIsViolentNoise(state, IsViolentNoise) {
      state.IsViolentNoise = IsViolentNoise;
    },
    
    setIsRedesSociais(state, IsRedesSociais) {
      state.IsRedesSociais = IsRedesSociais;
    },
    
    setIsContato(state, IsContato) {
      state.IsContato = IsContato;
    },
    
    setIsPatrocinador(state, IsPatrocinador) {
      state.IsPatrocinador = IsPatrocinador;
    },
    
    setBlogPosts(state, Posts)
    {
      state.BlogPosts = Posts;
    },

    addBlogPost(state, Post)
    {
      state.BlogPosts.push(Post);
    },

    setIdToken(state, IdToken) {
      state.IdToken = IdToken;
    },

    setIdTokenExp(state, IdTokenExp) {
      state.IdTokenExp = IdTokenExp;
    },

    setMessageToken(state, MessageToken) {
      state.MessageToken = MessageToken;
    },

    setUserId(state, UserId) {
      state.UserId = UserId;
    },

    setDisplayName(state, DisplayName)
    {
      state.DisplayName = DisplayName;
    },

    setEmail(state, Email)
    {
      state.Email = Email;
    },

    setPhoneNumber(state, PhoneNumber)
    {
      state.PhoneNumber = PhoneNumber;
    },

    setPhotoURL(state, PhotoURL)
    {
      state.PhotoURL = PhotoURL;
    },

    setClaims(state, Claims)
    {
      state.Claims = Claims;
    },

  },
  actions: {
  },
  modules: {
  }
})
